import React from 'react';
import PropTypes from 'prop-types';
import { SuiDropdownOption } from '@splashthat/sui';
import isNil from 'lodash/isNil';

import { DATE_DURATION_UNIT_DAYS, DATE_DURATION_UNIT_MONTHS } from 'common/entities/formNode/nodeConfig';

import { DurationContainer, DurationInputText, DurationDropdown } from './DateDuration.styles';

const DURATION_FROM_LABEL = 'from submission date';

const pluralize = (singularLocale, pluralLocale) => (value) => value === 1 ? singularLocale : pluralLocale;

const dateDurationOptions = [
    {
        getLabel: pluralize('day', 'days'),
        value: DATE_DURATION_UNIT_DAYS,
    },
    {
        getLabel: pluralize('month', 'months'),
        value: DATE_DURATION_UNIT_MONTHS,
    },
];

const DateDuration = (props) => (
    <DurationContainer>
        <DurationInputText
            type="number"
            pattern="^[0-9]"
            min="0"
            variation={props.error ? 'error' : ''}
            value={isNil(props.dateDurationValue) ? '' : props.dateDurationValue}
            onChange={(e, value) => e.target.validity.valid && props.setDateDurationValue(parseInt(value, 10))}
        />
        <DurationDropdown onChange={(_, option) => props.setDateDurationUnit(option)} value={props.dateDurationUnit}>
            {dateDurationOptions.map(({ getLabel, value }) => (
                <SuiDropdownOption key={value} value={value} displayValue={getLabel(props.dateDurationValue)} />
            ))}
        </DurationDropdown>
        <p>{DURATION_FROM_LABEL}</p>
    </DurationContainer>
);

DateDuration.propTypes = {
    error: PropTypes.bool,
    dateDurationValue: PropTypes.number.isRequired,
    dateDurationUnit: PropTypes.string.isRequired,
    setDateDurationValue: PropTypes.func.isRequired,
    setDateDurationUnit: PropTypes.func.isRequired,
};

DateDuration.defaultProps = {
    error: null,
};

export default DateDuration;
